import { combineReducers } from 'redux';

function session(state = '', action = {}) {
    switch (action.type) {
        case 'STORE_INFO':
            return action.session;
        default:
            return state;
    }
}

function tenantsReducer(state = {}, action = {}) {
    switch (action.type) {
        case 'SET_TENANT': {
            return {
                ...state,
                [action.tenantId]: {
                    error: false,
                    isStale: false,
                    tenant: action.tenantData
                }
            };
        }
        case 'SET_TENANT_ERROR': {
            return {
                ...state,
                [action.tenantId]: {
                    error: true,
                    isStale: false,
                    tenant: null
                }
            };
        }
        case 'TENANT_IS_STALE': {
            const tenantState = state[action.tenantId];

            return {
                ...state,
                [action.tenantId]: {
                    ...tenantState,
                    isStale: true
                }
            };
        }
        default:
            return state;
    }
}

const rootReducer = combineReducers({
    session,
    tenants: tenantsReducer
});

export default rootReducer;
